<template>
  <div class="container">
    <a-button
      type="primary"
      @click="openAdd = true"
      style="margin-bottom: 16px"
    >
      添加管理员
    </a-button>
    <a-table
      :columns="columns"
      :data-source="mailList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        onChange: handleChange,
      }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openAdd"
      title="添加管理员数据"
      @ok="submitAdd"
      cancelText="取消"
    >
      <a-form :model="addRequest">
        <a-form-item label="管理员名称">
          <a-input v-model:value="addRequest.account" />
        </a-form-item>
        <a-form-item label="密码">
          <a-input-password v-model:value="addRequest.password" />
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input-password v-model:value="addRequest.check_password" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:open="openUpdate"
      title="修改快递数据"
      @ok="submitUpdate"
      cancelText="取消"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="管理员名称">
          <a-input v-model:value="updateRequest.account" />
        </a-form-item>
        <a-form-item label="密码">
          <a-input-password v-model:value="updateRequest.password" />
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input-password v-model:value="updateRequest.check_password" />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { AdminService } from "@/api/services/AdminService";
import { ListRequest } from "@/api/models/ListRequest";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Admin } from "@/api/models/admin/Admin";
import { AdminAddRequest } from "@/api/models/admin/AdminAddRequest";
import { AdminUpdateRequest } from "@/api/models/admin/AdminUpdateRequest";

const total = ref<number>(0);

const listRequest = reactive<ListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const mailList = ref<Admin[]>([]);

const handleList = async () => {
  const res = await AdminService.ListAll(listRequest);
  if (res.code === 0) {
    mailList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<AdminAddRequest>({
  account: "",
  password: "",
  check_password: "",
});

const submitAdd = async () => {
  const res = await AdminService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<AdminUpdateRequest>({
  id: 0,
  is_delete: 1,
  account: "",
  password: "",
  check_password: "",
});

const handleUpdate = (record: Admin) => {
  openUpdate.value = true;
  updateRequest.account = record.account;
  updateRequest.id = record.id;
  updateRequest.is_delete = record.is_delete;
};

const submitUpdate = async () => {
  const res = await AdminService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Admin) => {
  const res = await AdminService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Admin) => {
  const res = await AdminService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "账号",
    dataIndex: "account",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}
</style>
